import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';

// Fetch Expenses
export const fetchExpenses = createAsyncThunk(
  'expenses/fetch',
  async ({ startDate, endDate, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}expenses`, {
        params: {
          startDate,
          endDate,
          userId
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch expenses'));
    }
  }
);

// Fetch expense by ID
export const fetchExpenseById = createAsyncThunk(
  'expenses/fetchExpenseById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}expenses/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch expense by id'));
    }
  }
);

// Create new expense
export const createExpense = createAsyncThunk(
  'expenses/createExpense',
  async (expenseData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}expenses`, expenseData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to create expense'));
    }
  }
);

// Update expense
export const updateExpense = createAsyncThunk(
  'expense/updateExpense',
  async ({ id, expenseData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}expenses/${id}`, expenseData);
      return response.data.data.expense;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update expense'));
    }
  }
);

// Delete expense
export const deleteExpense = createAsyncThunk(
  'expense/deleteExpense',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${BASE_URL}expenses/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to delete expense'));
    }
  }
);

// Fetch monthly expenses
export const fetchMonthlyExpenses = createAsyncThunk(
  'expenses/fetchMonthlyExpenses',
  async ({ month, year, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}expenses/monthly`, {
        params: { month, year, page, limit }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch monthly expenses'));
    }
  }
);

// Fetch monthly expense details
export const fetchMonthlyExpenseDetails = createAsyncThunk(
  'expenses/fetchMonthlyExpenseDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}expenses/monthly/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch monthly expense details'));
    }
  }
);

export const updateMonthlyExpenseStatus = createAsyncThunk(
  'expenses/updateMonthlyStatus',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}expenses/monthly/${id}/status`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error,'Failed to update expense status'));
    }
  }
);

// Fetch User Expenses
export const fetchUserExpenses = createAsyncThunk(
  'expenses/fetchUserExpenses',
  async ({ startDate, endDate, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}expenses`, {
        params: {
          startDate,
          endDate,
          userId
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch user expenses'));
    }
  }
);

// Approve Expense
export const approveExpense = createAsyncThunk(
  'expenses/approve',
  async ({ expenseId, status, comment }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}expenses/approve`, {
        expenseId,
        status,
        comment
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to approve expense'));
    }
  }
);